import React from 'react'
import Translator from '../translator'
import Settings from '../settings'
import { CheckmarkWhiteIcon } from '../shared/checkmarkWhiteIcon'

export function CartNavigation({ step }) {
  const steps = [
    {
      title: Translator.translate('Kurv', 'cart-navigation'),
      url: Settings.getSetting('cart_url', 'cart-navigation')
    },
    {
      title: Translator.translate('Betalingsadresse', 'cart-navigation'),
      url: Settings.getSetting('payment_address_url', 'cart-navigation')
    },
    {
      title: Translator.translate('Godkendelse & betaling', 'cart-navigation'),
      url: Settings.getSetting('payment_method_url', 'cart-navigation')
    },
    {
      title: Translator.translate('Bekræftelse', 'cart-navigation'),
      url: Settings.getSetting('order_confirmation_url', 'cart-navigation')
    }
  ]

  const steps_html = steps.map((step_settings, index) => {
    var class_names = ['mtt-cart-navigation__item']

    if (index < step) {
      class_names.push('mtt-cart-navigation__item--checked')
    } else if (index === step) {
      class_names.push('mtt-cart-navigation__item--current')
    }

    return index <= step ? (
      <React.Fragment key={index}>
        {index > 0 ? (
          <div className='mtt-cart-navigation__divider'></div>
        ) : null}
        <a href={step_settings.url} className={class_names.join(' ')}>
          <CheckmarkWhiteIcon />
          <span>{step_settings.title}</span>
        </a>
      </React.Fragment>
    ) : (
      <React.Fragment key={index}>
        {index > 0 ? (
          <div className='mtt-cart-navigation__divider'></div>
        ) : null}
        <span className={class_names.join(' ')}>
          <CheckmarkWhiteIcon />
          <span>{step_settings.title}</span>
        </span>
      </React.Fragment>
    )
  })

  return <div className='mtt-cart-navigation'>{steps_html}</div>
}
